@let accessibleProducts = accessibleProducts$ | async;
@let activeProduct = activeProduct$ | async;

@if (version() === "vfo1") {
  <button
    #menuTrigger="menuTrigger"
    [class.tw-p-3]="sideNavOpen()"
    [class.tw-justify-between]="sideNavOpen()"
    [class.tw-rounded-2xl]="sideNavOpen()"
    [class.tw-p-1]="!sideNavOpen()"
    [class.tw-py-3]="!sideNavOpen()"
    [class.!tw-pe-0]="!sideNavOpen()"
    [class.tw-rounded-lg]="!sideNavOpen()"
    [class.tw-justify-center]="!sideNavOpen()"
    [class.tw-bg-bg-nav-hover]="menuTrigger.isOpen()"
    class="tw-w-full focus-visible:!tw-ring-fg-nav focus-visible:!tw-ring-2 focus-visible:!tw-ring-inset focus-visible:tw-outline-none focus-visible:tw-bg-bg-nav-hover hover:tw-bg-bg-nav-hover tw-flex tw-items-center"
    type="button"
    [attr.aria-label]="'switchProducts' | i18n"
    [bitMenuTriggerFor]="navSwitcherMenu"
    [bitPopoverAnchorFor]="switchProductsCoachmark.popover()"
    [popoverOpen]="coachmark.isStepActive('switchProducts')"
    [position]="coachmark.getStepPosition('switchProducts')"
    [closeOnBackdropClick]="false"
    [spotlight]="coachmark.isStepActive('switchProducts')"
  >
    <div class="tw-flex tw-items-center tw-gap-3 tw-min-w-0">
      @if (activeProduct) {
        <bit-icon-tile
          [size]="sideNavOpen() ? 'base' : 'sm'"
          [icon]="activeProduct.icon"
          [variant]="tileVariant()"
        ></bit-icon-tile>
        @if (sideNavOpen()) {
          <span class="tw-truncate">{{ activeProduct.name }}</span>
        }
      }
    </div>
    <bit-icon name="bwi-up-down-btn"></bit-icon>
  </button>
  <vault-coachmark #switchProductsCoachmark stepId="switchProducts" />
  <bit-menu #navSwitcherMenu>
    <div
      role="none"
      class="tw-flex tw-flex-col tw-gap-1"
      [style.width]="'calc(' + sideNavWidthRem() + 'rem - 32px)'"
    >
      @for (product of accessibleProducts; track product.name) {
        <a
          bitMenuItem
          [routerLink]="product.appRoute"
          [attr.aria-current]="product.isActive ? 'page' : null"
          [attr.icon]="product.icon"
          [class.tw-bg-bg-brand-softer]="product.isActive"
          [class.tw-text-fg-heading]="product.isActive"
          class="tw-transition-colors"
        >
          <bit-icon
            [class.tw-opacity-0]="!product.isActive"
            slot="start"
            [name]="'bwi-check'"
          ></bit-icon>
          <bit-icon slot="start" [name]="product.icon"></bit-icon>
          {{ product.name }}
        </a>
      }
    </div>
  </bit-menu>
} @else {
  @if (accessibleProducts && accessibleProducts.length > 1) {
    <bit-nav-divider></bit-nav-divider>
    <!-- [attr.icon] is used to keep the icon attribute on the bit-nav-item after prod mode is enabled. Matches other navigation items and assists in automated testing. -->
    @for (product of accessibleProducts; track product.name) {
      <bit-nav-item
        [icon]="product.icon"
        [text]="product.name"
        [route]="product.appRoute"
        [attr.icon]="product.icon"
        [forceActiveStyles]="product.isActive"
        focusAfterNavTarget="body"
      >
      </bit-nav-item>
    }
  }
}
